










import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { defineComponent } from '@vue/composition-api';
import AccountUserInfo from './AccountUserInfo.vue';

export default defineComponent({
    emits: ['profileClick'],
    props: {
        isExpanded: {
            type: Boolean,
            default: false,
        },
    },
    setup(_, { emit }) {
        function profileClick(isNotificationBadgeVisible: boolean) {
            emit('profileClick');
            AnalyticsSDK.getInstance().log(
                'Menu_iconAccount',
                {
                    eventLabel: isNotificationBadgeVisible ? 'Yes' : 'No',
                    notifications: isNotificationBadgeVisible ? 'Yes' : 'No',
                },
            );
        }

        return {
            profileClick,
        };
    },
    components: {
        AccountUserInfo,
    },
});
